import React from "react"
import moment from "moment"

import {FooterLink} from "./FooterLink"

export const CopyrightFooter = ({forCosco}) => {
  const year = moment().year()
  const spacer = ' | '
  if (forCosco) {
    return (<div className="common-footer">
      <div>{'COPYRIGHT © ' + year + ' COSCO SHIPPING Lines - ALL RIGHTS RESERVED'}</div>
      <div>
        <FooterLink
           href="https://lines.coscoshipping.com/home/item?language=en-US"
        >Terms of Use</FooterLink>{spacer}
        <FooterLink
           href="https://beian.miit.gov.cn/"
        >沪ICP备13003917号-1</FooterLink>{spacer}
        <FooterLink
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000157"
        >沪公网安备31022102000157号</FooterLink>{spacer}
        <FooterLink
           href="https://beian.miit.gov.cn/"
        >沪ICP备16018315号-1</FooterLink>{spacer}
        <FooterLink
           href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31022102000135"
        >沪公网安备 31022102000135号</FooterLink>{spacer}
        <img src="/images/shgs.png"
             alt="上海工商"
             style={{width: 20, position: 'absolute'}}/>
        <div style={{marginLeft: 20, display: 'inline'}}></div>
        <FooterLink
           href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&amp;serial=9031000020200709093534000006070085-SAIC_SHOW_310000-20200928105913857526&amp;signData=MEUCIQDqAvUJpVMTTb+nqhKQxGRVZlqZg5/gRZ57cbs+OVvVhgIgIeTr6k4xGvFV2bJ75eDF97xgk05XZPH6k4/DfyT1H8Q="
        >上海工商</FooterLink>
      </div>
    </div>)
  }
  return null
}
